import { makeActions } from '@redux/crudCreator/actions';

export const MODEL_NAME = 'modal';
export const modalActions = makeActions(MODEL_NAME);

export const getAllModal = modalActions.getAll;
export const editModal = modalActions.edit;
export const createModal = modalActions.create;
export const getByIdModal = modalActions.getDataById;
